import BossModel from "@/models/BossModel";
import Airline from '@/models/Airline/Airline';
import Airport from "@/models/Airport/Airport";
import Classification from "@/models/Flight/Classification/Classification";
import ProductVersion from "@/models/Product/ProductVersion/ProductVersion";
import Stopover from "@/models/Flight/Stopovers";

export default class Flight extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'flight';

    /**
     *
     * @type {string}
     */
    static entity = 'flights';

    static fields() {
		return {
			id: this.number(null).nullable(),
			remarks: this.attr(null),
			payment_conditions: this.attr(null),
			extra_conditions: this.attr(null),
			is_retour: this.boolean(null),
			departure_airport_id: this.number(null).nullable(),
			arrival_airport_id: this.number(null).nullable(),
			airline_id: this.number(null).nullable(),
			product_version_id: this.number(null).nullable(),
			flight_classification_id: this.number(null).nullable(),
            airline: this.belongsTo(Airline, 'airline_id'),
            departureAirport: this.belongsTo(Airport, 'departure_airport_id'),
            arrivalAirport: this.belongsTo(Airport, 'arrival_airport_id'),
            classification: this.belongsTo(Classification, 'flight_classification_id'),
            productVersion: this.belongsTo(ProductVersion, 'product_version_id'),
            version: this.belongsTo(ProductVersion, 'product_version_id'),
            stopovers: this.belongsToMany(Airport, Stopover,'flight_id', 'airport_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     */
    Airline() {
        return this.getRelated('airline');
    }

    /**
     *
     * @returns {boolean|*}
     */
    ProductVersion() {
        return this.getRelated('productVersion');
    }
}
